import nbaLogo from '@sorare/core/src/assets/logos/nba/nba.svg';

import { Header as ScoutingCenterHeader } from '@sorare/marketplace/src/searchCommonPlayer/Header';

import bg from './assets/background.jpg';

export const Header = () => {
  return (
    <ScoutingCenterHeader
      leagueLogo={{ src: nbaLogo, alt: 'NBA-logo' }}
      backgroundImage={bg}
    />
  );
};
